import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden"
  },
  month: {
    display: "flex",
    alignItems: "center",
    lineHeight: "normal"
  },
  monthName: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    paddingLeft: 20,
    paddingRight: 4
  },
  dateEllipsis: {
    marginLeft: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    height: 17,
    width: 17
  }
}));
